import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

import SortField from "./enum/SortField";

const messagesAsc = defineMessages<SortField>({
  [SortField.UPDATED_AT]: {
    id: "listDrawer.sort.updatedAt.asc",
    defaultMessage: "Least recently modified",
    description: "Records list customization sort - Least recently modified",
  },
});

const messagesDesc = defineMessages<SortField>({
  [SortField.UPDATED_AT]: {
    id: "listDrawer.sort.updatedAt.desc",
    defaultMessage: "Most recently modified",
    description: "Records list customization sort - Most recently modified",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: SortField,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
